import { PainScaleIconType, PainScaleType } from './pain-scale-type';
const VISUAL_REP_COMPLEX_DATA = {
    horizontalView: false,
    options: [
        {
            color: '#9DD3E3',
            group: 1,
            groupLabel: 'vital-sign.radio-pain-scale-painless',
            icon: PainScaleIconType.PAINLESS,
            value: 0,
        },
        {
            color: '#9DD3E3',
            group: 2,
            groupLabel: 'tws.light-pain-scale',
            icon: PainScaleIconType.MILD_PAIN,
            value: 1,
        },
        {
            color: '#5CBCB7',
            group: 2,
            groupLabel: 'tws.light-pain-scale',
            icon: PainScaleIconType.MILD_PAIN,
            value: 2,
        },
        {
            color: '#299F8F',
            group: 2,
            groupLabel: 'tws.light-pain-scale',
            icon: PainScaleIconType.MILD_PAIN,
            value: 3,
        },
        {
            color: '#FFED5E',
            group: 3,
            groupLabel: 'vital-sign.radio-pain-scale-moderate',
            icon: PainScaleIconType.MODERATE_PAIN,
            value: 4,
        },
        {
            color: '#FFCD05',
            group: 3,
            groupLabel: 'vital-sign.radio-pain-scale-moderate',
            icon: PainScaleIconType.MODERATE_PAIN,
            value: 5,
        },
        {
            color: '#FAB700',
            group: 3,
            groupLabel: 'vital-sign.radio-pain-scale-moderate',
            icon: PainScaleIconType.MODERATE_PAIN,
            value: 6,
        },
        {
            color: '#FF9F19',
            group: 4,
            groupLabel: 'vital-sign.radio-pain-scale-intense',
            icon: PainScaleIconType.INTENSE_PAIN,
            value: 7,
        },
        {
            color: '#FF830F',
            group: 4,
            groupLabel: 'vital-sign.radio-pain-scale-intense',
            icon: PainScaleIconType.INTENSE_PAIN,
            value: 8,
        },
        {
            color: '#F76700',
            group: 4,
            groupLabel: 'vital-sign.radio-pain-scale-intense',
            icon: PainScaleIconType.INTENSE_PAIN,
            value: 9,
        },
        {
            color: '#FF6D59',
            group: 5,
            groupLabel: 'vital-sign.radio-pain-scale-unbearable',
            icon: PainScaleIconType.UNBEARABLE_PAIN,
            value: 10,
        },
    ],
    references: 'tws.analogic-faces-reference',
    showColor: true,
    showValue: true,
    type: PainScaleType.VISUAL_REP_COMPLEX,
};
const VISUAL_REP_SIMPLE_DATA = {
    horizontalView: false,
    options: [
        {
            icon: PainScaleIconType.PAINLESS,
            value: 0,
        },
        {
            icon: PainScaleIconType.MILD_PAIN,
            value: 2.5,
        },
        {
            icon: PainScaleIconType.MODERATE_PAIN,
            value: 5,
        },
        {
            icon: PainScaleIconType.INTENSE_PAIN,
            value: 7.5,
        },
        {
            icon: PainScaleIconType.UNBEARABLE_PAIN,
            value: 10,
        },
    ],
    references: 'tws.adapted-faces-reference',
    showColor: true,
    showValue: true,
    type: PainScaleType.VISUAL_REP_SIMPLE,
};
const VISUAL_REP_LIGHT_DATA = {
    horizontalView: false,
    options: [
        {
            icon: PainScaleIconType.PAINLESS,
            value: 0,
        },
        {
            icon: PainScaleIconType.MILD_PAIN,
            value: 1,
        },
        {
            icon: PainScaleIconType.MODERATE_PAIN,
            value: 2,
        },
        {
            icon: PainScaleIconType.INTENSE_PAIN,
            value: 3,
        },
        {
            icon: PainScaleIconType.UNBEARABLE_PAIN,
            value: 4,
        },
    ],
    references: 'tws.pain-scale-light-faces',
    showColor: true,
    showValue: false,
    type: PainScaleType.VISUAL_REP_SIMPLE,
};
export { VISUAL_REP_COMPLEX_DATA, VISUAL_REP_SIMPLE_DATA, VISUAL_REP_LIGHT_DATA };
//# sourceMappingURL=pain-scale-data.js.map